import React from 'react';
import { Form, Row, Col, Input, Collapse, Select, InputNumber } from 'antd';
import CustomBtn from '../buttons/CustomBtn'
import GhostTxt from '../texts/GhostTxt'

import './styles/InlineCollapsibleForm.css';

const { Panel } = Collapse;

class InlineCollapsibleForm extends React.Component {
  render() {
    const {
      form,
      formTitle = 'Formulario',
      formTitleColor = 'black',
      formFields = [{
                      name: 'defaultInput',
                      placeholder: 'DEFAULT INPUT',
                      rules: [{ required: true, message: 'Default input is required!' }],
                      span: 19
                  }],
      submitBtnText = 'Enviar',
      submitIconType = 'plus',
      submitBtnColor = 'white',
      submitTextColor = 'black',
      submitBorderColor = 'grey',
      onSubmitAction,
      backgroundColor='#ececec',
      visible = true,
    } = this.props;

    const { getFieldDecorator } = form;

    if(!visible) return null;

    return (
        <Collapse 
            defaultActiveKey={null} 
            expandIconPosition={'right'} 
            bordered={false}
            className="inline-coll-form"
        >
            <Panel 
                header={
                    <GhostTxt text={formTitle} color={formTitleColor}/>
                }
                style={{backgroundColor:backgroundColor}}
                key="1"
            >
                <div className="inline-coll-form-container">
                    <Form 
                        layout="horizontal" 
                        hideRequiredMark
                    >
                        <Row 
                            gutter={16} 
                            type="flex" 
                            justify="start" 
                            align="middle"
                        >
                            {formFields.map(field => (
                                <Col 
                                    span={field.span || 12} 
                                    key={field.name}
                                >
                                    <Form.Item>
                                        {getFieldDecorator(field.name, {
                                            rules: field.rules || [],
                                        })(
                                            field.type === 'numeric' ? (
                                                <InputNumber
                                                    id={field.name}
                                                    className="inline-coll-form-input"
                                                    placeholder={field.placeholder}
                                                    min={field.min}
                                                    max={field.max}
                                                    style={{ width: '100%', borderColor: submitBorderColor }}
                                                />
                                            ) : field.type === 'select' ? (
                                                <Select
                                                    id={field.name}
                                                    className="inline-coll-form-input"
                                                    placeholder={field.placeholder}
                                                    style={{borderColor:submitBorderColor}}
                                                >
                                                    {(field.options || []).map(opt => (
                                                    <Select.Option key={opt.value} value={opt.value}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <span
                                                            style={{
                                                            display: 'inline-block',
                                                            width: 14,
                                                            height: 14,
                                                            backgroundColor: opt.value,
                                                            borderRadius: '50%'
                                                            }}
                                                        />
                                                        {opt.label}
                                                        </div>
                                                    </Select.Option>
                                                    ))}
                                                </Select>
                                            ) : (
                                                <Input
                                                    id={field.name}
                                                    className="inline-coll-form-input"
                                                    placeholder={field.placeholder}
                                                    maxLength={field.maxLength || 100}
                                                    style={{borderColor:submitBorderColor}}
                                                />
                                            )
                                        )}
                                    </Form.Item>
                                </Col>
                            ))}
                            <Col span={5}>
                                <Form.Item>
                                    <CustomBtn
                                        color={submitBtnColor}
                                        text={submitBtnText}
                                        textColor={submitTextColor}
                                        borderColor={submitBorderColor}
                                        iconType={submitIconType}
                                        onClick={onSubmitAction}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Panel>
        </Collapse>
    );
  }
}

export default Form.create()(InlineCollapsibleForm);